import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PermissionGuard from './Permissions/PermissionGuard';

const ProtectedRoute = ({ children, requirePermissions = false }) => {
  const user = useSelector((state) => state?.user?.user);
  const location = useLocation();
  
  // First check authentication
  if (!user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }
  
  // If permissions are required, wrap with PermissionGuard
  if (requirePermissions) {
    return (
      <PermissionGuard>
        {children}
      </PermissionGuard>
    );
  }
  
  // Otherwise just return the children
  return children;
};

export default ProtectedRoute; 